module.exports = __webpack_public_path__ + "static/media/mast-head.28c1d77d.jpg";